import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useRef, useState } from 'react';

import { SandboxHeader } from 'components/SandboxHeader/SandboxHeader';

import NavBar from './NavBar';

const LayoutContext = createContext<HTMLDivElement | null>(null);

export const TwoPaneLayout: FC<PropsWithChildren> = ({ children }) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState<boolean>(false);
  const layoutRef = useRef<HTMLDivElement>(null);

  return (
    <LayoutContext.Provider value={layoutRef.current}>
      <div className="fixed top-0 z-50 w-full">
        <SandboxHeader />
      </div>
      <div className="flex h-full bg-white">
        <div className="flex h-full max-h-screen">
          <NavBar openMobile={isMobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
        </div>
        <div ref={layoutRef} className="relative flex min-w-page max-w-page flex-auto flex-col overflow-auto">
          {children}
        </div>
      </div>
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  return useContext(LayoutContext);
};
